document.addEventListener('DOMContentLoaded', () => {
    const sliderContainer = document.querySelector('.sm-gallery--layout-slider');
    if (!sliderContainer) return;

    const track = sliderContainer.querySelector('.sm-gallery-track');
    if (!track) return;

    const items = track.querySelectorAll('.sm-item');
    if (!items.length) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let speed = 0.8;
    let isPaused = false;

    const firstItem = items[0];
    let itemWidth = firstItem.offsetWidth + 24; // 24px gap
    let originalCount = Math.floor(items.length / 3);
    if (originalCount < 1) originalCount = items.length;
    let loopOffset = itemWidth * originalCount;

    const updateMeasurements = () => {
        itemWidth = firstItem.offsetWidth + 24;
        loopOffset = itemWidth * originalCount;
    };

    window.addEventListener('resize', updateMeasurements);

    requestAnimationFrame(() => {
        updateMeasurements();
        if (loopOffset > 0) {
            track.scrollLeft = loopOffset;
        }
    });

    const startAutoScroll = () => {
        if (!isDown && !isPaused) {
            track.scrollLeft += speed;
            if (loopOffset > 0) {
                if (track.scrollLeft >= loopOffset * 2) {
                    track.scrollLeft = loopOffset;
                } else if (track.scrollLeft <= 5) {
                    track.scrollLeft = loopOffset;
                }
            }
        }
        requestAnimationFrame(startAutoScroll);
    };

    track.addEventListener('mousedown', (e) => {
        isDown = true;
        track.classList.add('is-dragging');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => {
        isDown = false;
        isPaused = false;
        track.classList.remove('is-dragging');
    });

    track.addEventListener('mouseenter', () => {
        isPaused = true;
    });

    track.addEventListener('mouseup', () => {
        isDown = false;
        track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 2;
        track.scrollLeft = scrollLeft - walk;
    });

    track.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
    }, { passive: true });

    track.addEventListener('touchend', () => {
        isDown = false;
    });

    track.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        const x = e.touches[0].pageX - track.offsetLeft;
        const walk = (x - startX) * 2;
        track.scrollLeft = scrollLeft - walk;
    }, { passive: false });

    // Slider arrows
    const wrapper = sliderContainer.closest('.sm-gallery-wrapper') || sliderContainer.parentElement;
    const prevBtn = wrapper && wrapper.querySelector('.sm-slider-arrow--prev');
    const nextBtn = wrapper && wrapper.querySelector('.sm-slider-arrow--next');

    if (prevBtn && nextBtn) {
        const tempPause = () => {
            isPaused = true;
            setTimeout(() => { isPaused = false; }, 1500);
        };
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            tempPause();
            track.scrollBy({ left: -itemWidth, behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            tempPause();
            track.scrollBy({ left: itemWidth, behavior: 'smooth' });
        });
    }

    startAutoScroll();
});
